import jsona from '@/lib/jsona';
import RootStateCommit from '@/store/mixins/rootstate-commit';
import Guard1000 from '@/resources/guard-1000';

const MODULE_NAME = 'guard1000';
const DEFAULT_STATE = Object.freeze({
  data: {
    feeders: []
  },
  error: null
});

export default {
  /* eslint no-param-reassign: ["error", { "props": false }] */
  namespaced: true,
  state: { ...DEFAULT_STATE },
  mutations: {
    parseResponseData(state, response) {
      const responseParsed = jsona.deserialize(response);

      state.data = responseParsed;
    },
    setError(state, error) {
      state.error = error;
    },
    resetFaultPanelData(state) {
      state.data = {};
    },
    resetStore(state) {
      Object.assign(state, DEFAULT_STATE);
    }
  },
  actions: {
    async fetchGuard1000({ commit }, guardParams) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);

      const { externalGuardId, projectCode, substationCode } = guardParams;

      try {
        const response = await Guard1000({ externalGuardId, projectCode, substationCode }).get({
          include: 'substation,substation.project,feeders'
        });

        if (!response) {
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);

          return Error(`Error while fetching ${MODULE_NAME}`);
        }

        commit('parseResponseData', response.body);

        RootStateCommit(commit, 'stopLoading', MODULE_NAME);
      } catch (error) {
        commit('setError', error.body);

        RootStateCommit(commit, 'setResponseError', MODULE_NAME);
        RootStateCommit(commit, 'stopLoading', MODULE_NAME);
      }
    },
    async editGuard1000({ commit }, { projectCode, substationCode, externalGuardId, data }) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      commit('setError', null);

      try {
        const response = await Guard1000({ externalGuardId, projectCode, substationCode }).update({
          ...data
        });

        if (!response) throw new Error(`No response while editing ${MODULE_NAME}`);

        RootStateCommit(commit, 'stopLoading', MODULE_NAME);
      } catch (error) {
        commit('setError', error.body);

        RootStateCommit(commit, 'setResponseError', MODULE_NAME);
        RootStateCommit(commit, 'stopLoading', MODULE_NAME);
      }
    },
    async removeGuard1000({ commit }, { projectCode, substationCode, externalGuardId }) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      commit('setError', null);

      try {
        const response = await Guard1000({ projectCode, substationCode, externalGuardId }).delete();

        if (!response) throw new Error(`No response while removing ${MODULE_NAME}`);

        RootStateCommit(commit, 'stopLoading', MODULE_NAME);
      } catch (error) {
        commit('setError', error.body);

        RootStateCommit(commit, 'setResponseError', MODULE_NAME);
        RootStateCommit(commit, 'stopLoading', MODULE_NAME);
      }
    }
  },
  getters: {
    diagrams: state => [[], ...state.data.feeders.map(feeder => feeder.diagrams)],
    feederDiagrams: (state, getters) => feederNumber => getters.diagrams[feederNumber + 1] || []
  }
};
